import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Button } from './Button';
import { everythingIncluded, noMore, scratchTasks } from '../data/includes';
import { CHECKOUT_URL, trackInitiateCheckout } from '../utils/tracking';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-rose-900 text-white" data-id="element-104" data-mp="84nqyiga5bq7">
      <div className="max-w-4xl mx-auto" data-id="element-105" data-mp="87jrmejiieic">
        <div className="text-center mb-16" data-id="element-106" data-mp="m46nsf3n50n7">
          <p className="text-white/70 font-semibold tracking-widest uppercase text-xs mb-3" data-id="element-107" data-mp="m2vl6ilxlyxo">
            Your Next Teaching Week
          </p>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="text-3xl md:text-5xl font-serif font-bold mb-6 leading-tight" data-id="element-108" data-mp="vv9npdku39kw">
            You can spend the next few days continuing to build your classes
            from scratch.
          </motion.h2>

          <p className="text-xl text-white/80 max-w-2xl mx-auto mb-8" data-id="element-109" data-mp="2m344p69twsiv">
            {scratchTasks.join(' ')}
          </p>

          <p className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight text-rose-200" data-id="element-110" data-mp="2r2yroyqhgxyn">
            Or... you can start your next teaching week with a complete 6-in-1
            visual teaching system already prepared.
          </p>

          <ul className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white/10 p-8 rounded-2xl border border-white/20" data-id="element-111" data-mp="300944nf1et55">
            {noMore.map(item => <li key={item} className="flex items-start gap-3" data-id="element-112" data-mp="39r3rxw7xm0sp">
                <span className="text-rose-200 mt-1" aria-hidden="true" data-id="element-113" data-mp="3es1jv0iqu97e">
                  ✦
                </span>
                <span className="text-white/90" data-id="element-114" data-mp="3isbrehm6p7od">{item}</span>
              </li>)}
          </ul>

          <p className="text-xl mb-2" data-id="element-115" data-mp="1jpeljhvznev5">
            Makeup Instructor Ready Doesn't Make You a Makeup Educator.
          </p>
          <p className="text-2xl font-bold text-rose-200 mb-6" data-id="element-116" data-mp="1er3d9blcdcf1">
            You're already the professional.
          </p>
          <p className="text-xl text-white/90" data-id="element-117" data-mp="1sihy7nyt7noq">
            What Makeup Instructor Ready gives you is the structure, visual
            resources and teaching system to put your knowledge into action more
            consistently.
          </p>
        </div>

        <div className="bg-white text-stone-800 rounded-3xl p-8 md:p-12" data-id="element-118" data-mp="1xeyk0bijdpyn">
          <h3 className="text-2xl font-bold mb-6 text-center border-b border-stone-200 pb-6" data-id="element-119" data-mp="2bfstkxhblwyw">
            Everything Included
          </h3>

          <ul className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-120" data-mp="27epcy8rg7wwm">
            {everythingIncluded.map(item => <li key={item} className="flex items-start gap-3" data-id="element-121" data-mp="h3bbe4bc9n14">
                <Check size={18} className="text-rose-700 shrink-0 mt-0.5" aria-hidden="true" data-id="element-122" data-mp="d1hf0886f56r" />
                <span className="text-sm text-stone-600" data-id="element-123" data-mp="6xtaqer1k52e">{item}</span>
              </li>)}
          </ul>

          <div className="text-center" data-id="element-124" data-mp="3pahlv1eiywsg">
            <div className="mb-8 p-6 bg-stone-100 rounded-xl border border-stone-200 italic text-stone-600 text-lg" data-id="element-125" data-mp="3p9q4ovlod1lp">
              “The best time to have a complete teaching system was before the
              last class you had to improvise.
              <br data-id="element-126" data-mp="3kcpx2g96fqsh" />
              <span className="text-rose-900 font-bold not-italic" data-id="element-127" data-mp="3kd9431xagurq">
                The second best time is before your next class.
              </span>
              ”
            </div>

            <p className="text-xl font-serif font-bold mb-2" data-id="element-128" data-mp="3bct25ww71voz">
              Makeup Instructor Ready
            </p>
            <p className="text-sm text-stone-500 mb-8" data-id="element-129" data-mp="14lv1f6acrvkf">
              6 Complete Visual Volumes, 150 Ready-to-Teach Makeup Classes and 5
              Exclusive Bonuses created to help makeup educators prepare less,
              teach with more structure and give students a clearer learning
              experience.
            </p>

            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackInitiateCheckout} className="w-full md:w-auto text-lg md:text-xl py-5 px-10 mb-6" data-id="element-130" data-mp="30mn8y3859rer">
              GET MAKEUP INSTRUCTOR READY NOW
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-stone-500" data-id="element-131" data-mp="2mqi90zaohjht">
              <span data-id="element-132" data-mp="2hvvw2roy7ivm">7-Day Guarantee</span>
              <span data-id="element-133" data-mp="2cychtrs9363o">·</span>
              <span data-id="element-134" data-mp="2cznllrlp4dus">Instant Digital Access</span>
              <span data-id="element-135" data-mp="27zsw9shkjwbu">·</span>
              <span data-id="element-136" data-mp="280kfe3tzc1l8">One-Time Payment</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}